import { createFileRoute } from '@tanstack/react-router';
// Login is the first authenticated page loaded — direct import avoids barrel on cold start.
// The auth/ barrel is small (2 re-exports: LoginForm + ResetPasswordForm) so the cost is
// minimal, but we keep this pattern for consistency with other eagerly-loaded routes.
import { LoginForm } from '@amber-ui/core/src/component/auth';

export const Route = createFileRoute('/login')({
  component: LoginForm,
});
